import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaxAttributesComponent } from '../tax-attributes.component';

@Component({
    selector: 'app-tax-attributes-entity-posting-form',
    templateUrl: './tax-attributes-entity-posting-form.component.html',
    styleUrls: ['../tax-attributes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaxAttributesEntityPostingFormComponent {
  @Input() ctx!: TaxAttributesComponent;
}
